// extracted by css-extract-rspack-plugin
export default {"backButton":"backButton-lQ5Trt","pageHeaderDivider":"pageHeaderDivider-jNjSgY","pageTitle":"pageTitle-G80k0U","pageHeader":"pageHeader-Li2BF3"};